export function useExplainFlag() {
    return window.location.href.includes("explain=true");
}
